import CmsPage from "./CmsPage";

const Contact = () => {
  return <CmsPage slug="contact" titleFallback="Contact" />;
};

export default Contact;
